const { selectTextInElement } = require('@/functions/dom');

/**
 * Highlights text in the element when it is clicked on (focused).
 *
 * @return {{link: Function}}
 */
const selectOnFocusDirective = function () {
    return {
        link: function (scope, element) {
            element.on('focus', function () {
                selectTextInElement(element[0]);
            });

            // This makes the select more reliable, but it means you can't click on
            // a specific point in the field to insert text there. I think having it is better.
            // You can use the left/right arrow keys to insert text at a specific point.
            element.on('click', function () {
                selectTextInElement(element[0]);
            });
        },
    };
};

module.exports = selectOnFocusDirective;
